import {React} from '@api';

import styled from '@react-pdf/styled-components'

/* https://app.zeplin.io/project/5db1a9513b7725126d421cdb/screen/5db1a975e3284023b2fd5516 */

export const MyReportPage = styled.Page`
  padding: 20px 36px;
  display:flex;
  flex-direction: column;
  font-size:8pt;
  font-family: Arial;
`

export const Products = styled.View`
  display: flex;
  flex-grow:1;
  flex-direction: column;
  align-content: flex-start;
  width:100%;        
`

export const ProductRow = styled.View`
  display: flex;
  flex-grow:0;
  flex-shrink:1;
  flex-direction: row;
  justify-content: flex-start;
  overflow: hidden;
  flex-wrap: nowrap;
  margin-top:0px;
`

export const CardContainer = styled.View`
  overflow:hidden;
  margin: 0 10px 10px 0;
  flex-shrink:0;
  display:flex;
  flex-direction: column;
`

export const Title = styled.View`
  display:flex;
  flex-direction: row;
  width:100%;
  z-index:1;
  margin-bottom:10px;
`

export const Footer = styled.View`
position:absolute;
left: 36px;
bottom:20px;
  font-size: 8pt;
  display:flex;
  flex-direction: row;
  width:100%
`

export const Left = styled.View`
  display:flex;
  flex-direction: row;  
`

export const Right = styled.View`
  display:flex;
  flex-direction: row;
  margin-left:auto;
`

export const BrandLogo = styled.Image`
  flexGrow:0;  
  width:100px;
`

export const Breadcrumbs = styled.Text`
  display:flex;
  text-transform: capitalize;
`

export const BrandNameText = styled.Text`
  font-family:Arial Bold;
  font-weight: bold;
  text-transform: uppercase;
  
`
export const VersionText = styled(BrandNameText)`
  font-size: 9px;
`

export const CurrentDateText = styled.Text`
text-transform: uppercase;  
`

export const PageNumberText = styled.Text`
  display:flex;
  flex-direction: row;
`



// WEBPACK FOOTER //
// ./src/modules/pdf/templates/ysl/product/YslProductPage.styles.tsx